const isAValidUrl=(value: string): boolean=> {
    try {
      const url = new URL(value);
      return true;
    } catch (TypeError) {
      return false;
    }
  }
  export default isAValidUrl